<template>
  <b-container fluid v-if="items && fields" class="custom-b-table" :class="{ 'p-0': noGutters }">
    <b-row>
      <b-col lg="3" class="my-2 itemstotal width col-sm-6" role="itemstotal" v-if="showTotal && !showButton"> Total Forms/Activities: {{ totalItems }} </b-col>
      <b-col lg="3" class="my-2 itemstotal width-query col-sm-6" role="itemstotal" v-if="showTotal && !showButton">
        {{ printTotal }}
      </b-col>

      <b-col lg="3" class="my-2 itemstotal col-sm-6" role="itemstotal" v-if="showButton && showTotal">
        {{ printTotal }}
      </b-col>
      <b-col lg="3" class="my-2 itemstotal col-sm-6" role="itemstotal" v-if="showButton && showTotal">
        <b-btn size="sm" class="fs-12 pull-right" variant="outline-primary" @click="btnClick">
          {{ btnText }}
        </b-btn>
      </b-col>
      <b-col lg="3" class="search col-sm-12 mb-10" v-if="showTotal && !showButton">
        <input type="text" class="form-control mb-0 br-3 search-field" placeholder="Search Participant ID or THREAD ID" v-model="dashFilterData.participantId" @keyup.enter="dataDashboardFilterChange" />
      </b-col>
      <b-col lg="1" class="filters col-sm-3 mb-10" v-if="showFilter">
        <div class="multiselect filter-form-box" id="CountrySelectBox" ref="status-select">
          <div class="selectBox" @click="showCheckboxesStatus">
            <div class="fakeclass">
              <input name="country" value="Filters" class="form-control input-md cursor-pointer d-block" id="select-country" readonly :tabindex="10" />
            </div>
          </div>
          <div id="showCheckboxesCountry" class="select-scroll activity-builder-select-options" v-if="isDisplayStatusCheckBoxes">
            <input type="text" class="filter-search-bar search-bar" placeholder="Search Filters" v-model="searchedStatus" />
            <div class="check_label_input d-flex custom-control custom-checkbox" v-for="status in getfilterOptions" :key="status.value">
              <input class="custom-control-input" v-model="dashFilterData.status" :id="status.value" type="checkbox" :value="status.value" @change="dataDashboardFilterChange" />
              <label class="custom-control-label" :for="status.value">{{ status.text }}</label>
            </div>
            <div v-if="getfilterOptions.length === 0" class="text-nowrap">
              <label>No filter found.</label>
            </div>
          </div>
        </div>
      </b-col>
      <b-col lg="1" class="filters col-sm-3" v-if="showFilter">
        <div class="multiselect filter-form-box" id="CountrySelectBox" ref="country-select">
          <div class="selectBox" @click="showCheckboxesCountry">
            <div class="fakeclass">
              <input name="country" value="Country" class="form-control input-md cursor-pointer d-block" id="select-country" readonly :tabindex="10" />
            </div>
          </div>
          <div id="showCheckboxesCountry" class="select-scroll activity-builder-select-options" v-if="isDisplayCountryCheckBoxes">
            <input type="text" class="search-bar" placeholder="Search Countries" v-model="searchedCountry" />
            <div class="check_label_input d-flex custom-control custom-checkbox" v-for="country in countryOptions" :key="country.countryId">
              <input class="custom-control-input" v-model="dashFilterData.country" :id="country.countryId" type="checkbox" :value="country.countryId" @change="dataDashboardFilterChange" />
              <label class="custom-control-label" :for="country.countryId">{{ country.countryName }}</label>
            </div>
            <div v-if="countryOptions.length === 0" class="text-nowrap">
              <label>No filter found.</label>
            </div>
          </div>
        </div>
      </b-col>
      <b-col lg="2" class="filters col-sm-3" v-if="showFilter">
        <div class="multiselect filter-form-box" id="CountrySelectBox" ref="milestone-select">
          <div class="selectBox" @click="showCheckboxesMilestone">
            <div class="fakeclass">
              <input name="country" value="Milestone" class="form-control input-md cursor-pointer d-block" id="select-country" readonly :tabindex="10" />
            </div>
          </div>
          <div id="showCheckboxesCountry" class="select-scroll activity-builder-select-options" v-if="isDisplayMilestoneCheckBoxes">
            <input type="text" class="search-bar" placeholder="Search Milestones" v-model="searchedMilestone" />
            <div class="check_label_input d-flex custom-control custom-checkbox" v-for="milestone in milestoneOptions" :key="milestone.milestoneId">
              <input class="custom-control-input" v-model="dashFilterData.milestone" :id="milestone.milestoneId" type="checkbox" :value="milestone.milestoneId" @change="dataDashboardFilterChange" />
              <label class="custom-control-label" :for="milestone.milestoneId">{{ milestone.milestoneName }}</label>
            </div>
            <div v-if="milestoneOptions.length === 0" class="text-nowrap">
              <label>No filter found.</label>
            </div>
          </div>
        </div>
      </b-col>
      <b-col lg="1" class="filters col-sm-3" v-if="showFilter">
        <div class="multiselect filter-form-box" id="CountrySelectBox" ref="site-select">
          <div class="selectBox" @click="showCheckboxesSite">
            <div class="fakeclass">
              <input name="country" value="Site" class="form-control input-md cursor-pointer d-block" id="select-country" readonly :tabindex="10" />
            </div>
          </div>
          <div id="showCheckboxesCountry" class="select-scroll activity-builder-select-options" v-if="isDisplaySiteCheckBoxes">
            <input type="text" class="search-bar" placeholder="Search Sites" v-model="searchedSite" />
            <div class="check_label_input d-flex custom-control custom-checkbox" v-for="site in siteOptions" :key="site.id">
              <input class="custom-control-input" v-model="dashFilterData.siteId" :id="site.id" type="checkbox" :value="site.id" @change="dataDashboardFilterChange" />
              <label class="custom-control-label" :for="site.id">{{ site.userSiteId }}</label>
            </div>
            <div v-if="siteOptions.length === 0" class="text-nowrap">
              <label>No filter found.</label>
            </div>
          </div>
        </div>
      </b-col>
      <b-col lg="2" class="my-1 col-sm-3" role="itemsfilter" v-if="showFilter && !filterOptions">
        <b-form-group>
          <b-input-group>
            <b-form-input :value="filterModel" @input="onFilterChange" @change="onFilterChange" :placeholder="filterPlaceholderMessage" />

            <b-input-group-button>
              <b-button @click="onFilterChange('')">Clear</b-button>
            </b-input-group-button>
          </b-input-group>
        </b-form-group>
      </b-col>
    </b-row>

    <b-row :noGutters="noGutters">
      <b-col :class="showTable == false ? 'display-none' : ''">
        <component :is="tableWrapperComponent" :noGutters="noGutters" :class="{'border-0 shadow': tableWrapperComponent === 'b-card'}">
          <b-table
            :fields="fields"
            :items="items"
            :id="id"
            :sortBy="sortBy"
            :sortDesc="sortDesc"
            :noProviderPaging="noProviderPaging"
            :noProviderSorting="noProviderSorting"
            :noProviderFiltering="noProviderFiltering"
            :filter="filterRegexValid(filterModel)"
            :per-page="perPage"
            :current-page="currentPageModel"
            :showEmpty="showEmpty"
            :emptyText="emptyText"
            :emptyFilteredText="emptyText"
            @row-clicked="(...args) => transferListener('rowClicked', ...args)"
            @row-hovered="(...args) => transferListener('rowHovered', ...args)"
            @sort-changed="(...args) => transferListener('sortChanged', ...args)"
            @context-changed="(...args) => transferListener('contextChanged', ...args)"
            @filtered="onFiltered"
            @refreshed="(...args) => transferListener('refreshed', ...args)"
          >
            <template v-for="field in fields" :slot="field.key" slot-scope="row">
              <slot :name="field.key" :row="row">{{ row.value }}</slot>
            </template>
          </b-table>
        </component>
      </b-col>
    </b-row>

    <b-row :noGutters="noGutters" v-if="showPagination && totalItemsModel > perPage">
      <b-col md="6" class="my-1">
        <b-pagination :total-rows="totalItemsModel" :per-page="perPage" :value="currentPageModel" @change="onPageChange" class="my-0 pt-20" />
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { mapGetters } from "vuex";
import _ from "lodash";

export default {
  props: {
    showTable: {
      type: Boolean,
      default: true
    },
    fields: {
      // Array of objects: {key, label, class, sortable, formatter}
      type: Array,
      required: true
    },
    items: {
      // Array of objects
      type: [Array, Function],
      required: true
    },
    id: String,
    sortBy: String,
    btnText: String,
    sortDesc: Boolean,
    totalItems: Number,
    perPage: {
      type: Number,
      default: 0
    },
    currentPage: Number,
    filter: [String, RegExp, Function],
    filterOptions: Array,
    studyData: Object,
    noProviderPaging: {
      type: Boolean,
      default: false
    },
    noProviderSorting: {
      type: Boolean,
      default: false
    },
    noProviderFiltering: {
      type: Boolean,
      default: false
    },
    noGutters: {
      type: Boolean,
      default: false
    },
    showFilter: Boolean,
    showButton: Boolean,
    showPagination: Boolean,
    showTotal: Boolean,
    tableWrapperComponent: {
      type: String,
      default: "div"
    },
    printTotalFormatter: {
      type: Function,
      default: totalCount => `Total item count: ${totalCount}`
    },
    filterPlaceholderMessage: {
      type: String,
      default: "Type to Search"
    },
    filterLabelMessage: {
      type: String,
      default: "Filter"
    },
    showEmpty: {
      type: Boolean,
      default: false
    },
    emptyText: {
      type: String,
      default: "No documents available to view."
    }
  },
  data() {
    return {
      showHideSignOff: false,
      filteredItems: [],
      filterModel: this.filter || "",
      currentPageModel: this.currentPage || 1,
      searchedCountry: "",
      searchedSite: "",
      searchedMilestone: "",
      searchedStatus: "",
      searchTerm: "",
      isDisplayCountryCheckBoxes: false,
      isDisplaySiteCheckBoxes: false,
      isDisplayMilestoneCheckBoxes: false,
      isDisplayStatusCheckBoxes: false,
      dashFilterData: {
        status: [],
        country: [],
        siteId: [],
        milestone: [],
        participantId: ""
      }
    };
  },
  mounted() {
    this.hideCountryCheckBox();
    this.hideSiteCheckBox();
    this.hideMilestoneCheckBox();
    this.hideStatusCheckBox();
  },
  watch: {
    filter(newFilter) {
      this.filterModel = newFilter;
    },
    currentPage(newPage) {
      this.currentPageModel = newPage;
    }
  },
  computed: {
    ...mapGetters(["user"]),
    totalItemsModel() {
      const isItemProviderUsing = this.items instanceof Function;

      if (this.filterModel && (this.noProviderFiltering || !isItemProviderUsing)) {
        return this.filteredItems.length;
      }

      return this.totalItems || (!isItemProviderUsing ? this.items.length : 0);
    },
    printTotal() {
      return this.printTotalFormatter(this.totalItemsModel);
    },
    countryOptions() {
      if (!this.studyData) {
        return [];
      }
      const sortedCountries = _.sortBy(this.studyData.countryList, "countryName");
      return sortedCountries.filter(country => country.countryName.toLowerCase().includes(this.searchedCountry.toLowerCase()));
    },
    siteOptions() {
      if (!this.studyData) {
        return [];
      }
      let siteList = this.studyData.sitesInfo;

      if (this.user.siteTeamUser) {
        siteList = this.user.userSite
          .filter(site => site.studyId === this.studyData.studyId)
          .map(site => {
            return {
              id: site.siteId,
              userSiteId: site.userDefineSiteId
            };
          });
      }

      const sortedSites = _.sortBy(siteList, "userSiteId");
      return sortedSites.filter(site => site.userSiteId.toLowerCase().includes(this.searchedSite.toLowerCase()));
    },
    milestoneOptions() {
      if (!this.studyData) {
        return [];
      }
      const sortedMilestones = _.sortBy(this.studyData.milestonesList, "milestoneName");
      return sortedMilestones.filter(milestone => milestone.milestoneName.toLowerCase().includes(this.searchedMilestone.toLowerCase()));
    },
    getfilterOptions() {
      if (!this.studyData) {
        return [];
      }
      const sortedStatus = _.sortBy(this.filterOptions, "text");
      return sortedStatus.filter(status => status.text.toLowerCase().includes(this.searchedStatus.toLowerCase()));
    }
  },
  methods: {
    filterRegexValid(filter) {
      return filter != null && filter !== undefined ? filter.replace(/[\[\]]/g, "\\$&") : filter;
    },
    transferListener(listenerName, ...args) {
      this.$emit(listenerName, ...args);
    },
    onFiltered(filteredItems) {
      this.filteredItems = filteredItems;
      this.transferListener("filtered", filteredItems);
    },
    dataDashboardFilterChange() {
      const filter = JSON.stringify(this.dashFilterData);
      const payload = this.checkFilter();
      const filterData = Object.keys(payload).length > 0 ? payload : null;
      this.$emit("onFilterUpdate", filterData);
      this.onFilterChange(filter);
    },
    onFilterChange(value) {
      this.$emit("filterChanged", value);
      this.currentPageModel = 1;
      this.filterModel = value;
    },
    checkFilter() {
      const payload = {};
      Object.keys(this.dashFilterData).map(key => {
        if (this.dashFilterData[key].length > 0) {
          payload[key] = this.dashFilterData[key];
        }
      });
      return payload;
    },
    onPageChange(value) {
      this.$emit("pageChanged", value);
      this.currentPageModel = value;
    },
    btnClick() {
      this.$emit("tableBtn", this.btnText);
    },
    showCheckboxesCountry() {
      this.isDisplayCountryCheckBoxes = !this.isDisplayCountryCheckBoxes;
    },
    showCheckboxesSite() {
      this.isDisplaySiteCheckBoxes = !this.isDisplaySiteCheckBoxes;
    },
    showCheckboxesMilestone() {
      this.isDisplayMilestoneCheckBoxes = !this.isDisplayMilestoneCheckBoxes;
    },
    showCheckboxesStatus() {
      this.isDisplayStatusCheckBoxes = !this.isDisplayStatusCheckBoxes;
    },
    hideCountryCheckBox() {
      this.eventListenerToHideLanguageDropdown = document.addEventListener("click", event => {
        if (this.$refs["country-select"] && this.$refs["country-select"].contains(event.target)) {
        } else {
          this.isDisplayCountryCheckBoxes = false;
        }
      });
    },
    hideSiteCheckBox() {
      this.eventListenerToHideLanguageDropdown = document.addEventListener("click", event => {
        if (this.$refs["site-select"] && this.$refs["site-select"].contains(event.target)) {
        } else {
          this.isDisplaySiteCheckBoxes = false;
        }
      });
    },
    hideMilestoneCheckBox() {
      this.eventListenerToHideLanguageDropdown = document.addEventListener("click", event => {
        if (this.$refs["milestone-select"] && this.$refs["milestone-select"].contains(event.target)) {
        } else {
          this.isDisplayMilestoneCheckBoxes = false;
        }
      });
    },
    hideStatusCheckBox() {
      this.eventListenerToHideLanguageDropdown = document.addEventListener("click", event => {
        if (this.$refs["status-select"] && this.$refs["status-select"].contains(event.target)) {
        } else {
          this.isDisplayStatusCheckBoxes = false;
        }
      });
    }
  }
};
</script>

<style lang="scss" src="./styles/table.scss" />
